// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivateFooterBottom_container__MtMAj"};